export const getInitials = (val: string | string[]) => {
  const initials =
    typeof val === "string"
      ? val
          .split(" ")
          .map(v => v[0])
          .join("")
          .toUpperCase()
      : val
          .join(" ")
          .split(" ")
          .map(v => v[0])
          .join("")
          .toUpperCase();

  if (initials.length > 2) {
    return initials[0] + initials[initials.length - 1];
  } else {
    return initials;
  }
};
